<mat-toolbar color="primary" class="header px-sm-32 px-md-40 px-lg-80">
  <brand-logo *ngIf="logo" [src]="logo.url" [title]="logo.altText" [link]="['/']"
    [alt]="logo.altText"></brand-logo>
  <span class="header--spacer"></span>
  <ng-content select="[actions]">
  </ng-content>
</mat-toolbar>
